import { render, staticRenderFns } from "./gerceklesmebirim.vue?vue&type=template&id=22c0837a"
import script from "./gerceklesmebirim.vue?vue&type=script&lang=js"
export * from "./gerceklesmebirim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports